import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { questionValidation } from '../../functions/Validation';
import QuestionHelp from '../question/QuestionHelp';
import './number.scss';
import ValidationMessage from '../question/ValidationMessage';
import { tracking } from '../../functions/Tracking';
import { Action } from '../../enums/TrackingActionType';

export default function Number(props: any) {

    const [question, setQuestion] = useState(props.question);
    const [numberValue, setNumberValue] = useState(question.answer);
    const [minNumberValue, setMinNumberValue] = useState("0");
    const [secondsFocused, setSecondsFocused] = useState(0);
    const timerId = useRef<number>(0);

    let isPercentage = false;
    let isCurrency = false;

    if (props.question.questionSetQuestion.text.includes("percent")) {
        isPercentage = true;
    }

    if (props.question.questionSetAnswerType.answerTypeName.toLowerCase() === "largemoney") {
        isCurrency = true;
    }

    var inputClasses = classNames(
        {
            'validation-fail': question.validationFail,
            'currenty-input': isCurrency
        }
    );

    var labelClasses = classNames(
        {
            'validation-fail-lbl': question.validationFail
        }
    );


    useEffect(() => {
        setQuestion(props.question);
        if (props.question.answer) {
            setNumberValue(props.question.answer);
        }
        if (question.questionSetAnswerType.startRange !== null) {
            setMinNumberValue(question.questionSetAnswerType.startRange);
        }
    }, [])

    useEffect(() => {
        if (secondsFocused === 60) {
            //alert("Too much time has passed");
            //alert(question.questionSetQuestion.text);
        }
    }, [secondsFocused])

    useEffect(() => {
        if (numberValue < minNumberValue && numberValue !== "") {
            setNumberValue("");
        }

        question.answer = numberValue;
        setQuestion(question);
        props.enableQuestions(question.questionSetQuestion.questionID);
        props.resetCoverValidation();
    }, [numberValue]);

    const startTimer = () => {
        timerId.current = window.setInterval(() => {
            setSecondsFocused(prev => prev + 1);
        }, 1000);
    };

    const stopTimer = () => {
        clearInterval(timerId.current);
        setSecondsFocused(0);
    };

    const updateAnswer = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumberValue(e.target.value);
    };

    const validateAnswer = () => {
        stopTimer();
        tracking(Action.SAVE_QUESTIONS, question.questionSetQuestion.questionID);
        question.validationFail = !questionValidation(question);

        setQuestion(question);
    };

    return (
        <>
            <div className="question">
                <label className={labelClasses} htmlFor={"valen_" + question.questionSetQuestion.questionID}>{question.questionSetQuestion.text}</label>
                <br />
                <div className="input-number-wrapper" >
                    {isCurrency &&
                        <span className="currency">&pound;</span>}
                    <input
                        type="number"
                        value={numberValue}
                        id={"valen_" + question.questionSetQuestion.questionID}
                        className={inputClasses}
                        onChange={(e) => updateAnswer(e)}
                        onFocus={() => startTimer()}
                        onBlur={() => validateAnswer()}
                        min={minNumberValue}
                        max={question.questionSetAnswerType.endRange}
                    />
                </div>
                {isPercentage &&
                    <span>%</span>}
                {question.questionSetQuestion.helpText !== null && question.questionSetQuestion.helpText !== "" &&
                    <QuestionHelp helpText={question.questionSetQuestion.helpText} questionID={question.questionSetQuestion.questionID} />
                }
                {/*<p>Focused: {secondsFocused}</p>*/}
                {question.validationFail &&
                    <ValidationMessage question={question} overrideMessage="" />}
            </div>
        </>

    );
};